import { SearchConfigComponent } from './search-config/search-config.component';
import { ArchiveComponent } from './Publications/archive/archive.component';
import { RechercheComponent } from './recherche/recherche.component';
import { Page404Component } from './page404/page404.component';
import { PostulerComponent } from './Publications/postuler/postuler.component';
import { NewsletterComponent } from './Publications/newsletter/newsletter.component';
import { PlanSiteComponent } from './acces rapide/plan-site/plan-site.component';
import { LexiqueComponent } from './acces rapide/lexique/lexique.component';
import { ContactComponent } from './acces rapide/contact/contact.component';
import { VideothequeComponent } from './Publications/videotheque/videotheque.component';
import { PhotothequeComponent } from './Publications/phototheque/phototheque.component';
import { IFPComponent } from './Formation Portuaire/ifp/ifp.component';
import { TarifsPublicsPlafondsComponent } from './Espace Professionnel/tarifs-publics-plafonds/tarifs-publics-plafonds.component';
import { PortnetServicesComponent } from './Services/portnet-services/portnet-services.component';
import { PortnetComponent } from './Grands Chantiers/portnet/portnet.component';
import { SecuritePortuaireComponent } from './Grands Chantiers/securite-portuaire/securite-portuaire.component';
import { PortcontentComponent } from './Services/port-maroc/port-detail/portcontent/portcontent.component';
import { PortDetailComponent } from './Services/port-maroc/port-detail/port-detail.component';
import { ANPEnChiffresComponent } from './Agence/anpen-chiffres/anpen-chiffres.component';
import { CommuniquesPresseComponent } from './Publications/communiques-presse/communiques-presse.component';
import { PortMarocComponent } from './Services/port-maroc/port-maroc.component';
import { StatistiquesComponent } from './Services/statistiques/statistiques.component';
import { ChantiersInfrastructuresComponent } from './Grands Chantiers/chantiers-infrastructures/chantiers-infrastructures.component';
import { OrganisationComponent } from './Agence/organisation/organisation.component';
import { HistoriqueComponent } from './Agence/historique/historique.component';
import { StatiquePageComponent } from './statique-page/statique-page.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { PortComponent } from './Grands Chantiers/port/port.component';
import { RapportsAnnuelsComponent } from './Agence/rapports-annuels/rapports-annuels.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MvmNaviresComponent } from './Services/mvm-navires/mvm-navires.component';
import { SmartGateComponent } from './Services/smart-gate/smart-gate.component';
import { OffreDeFormationComponent } from './Formation Portuaire/offre-de-formation/offre-de-formation.component';
import { SimulateurComponent } from './Formation Portuaire/simulateur/simulateur.component';
import { ActualitesComponent } from './Publications/actualites/actualites.component';
import { AppelsOffresComponent } from './Publications/appels-offres/appels-offres.component';
import { OffresEmploisComponent } from './Publications/offres-emplois/offres-emplois.component';
import { Home2Component } from './home2/home2.component';
import { GestionAccessComponent } from './Services/gestion-access/gestion-access.component';
import { CentreMediaComponent } from './Publications/centre-media/centre-media.component';
import { ConsignationPortsComponent } from './Services/consignation-ports/consignation-ports.component';
import { StatistiquesNationalComponent } from './Services/statistiques-national/statistiques-national.component';
import { MvmNaviresAutoriseeComponent } from './Services/mvm-navires-autorisee/mvm-navires-autorisee.component';
import { AppelConcurrenceComponent } from './Services/appel-concurrence/appel-concurrence.component';
import { ProgrammePrevComponent } from './Services/programme-prev/programme-prev.component';
import { AppelConsurrence2Component } from './Services/appel-consurrence2/appel-consurrence2.component';
import { SocietesautoriseesComponent } from './Services/societesautorisees/societesautorisees.component';
import { AppelManifestationComponent } from './Services/appel-manifestation/appel-manifestation.component';
import { DeposerCandidatureComponent } from './Publications/deposer-candidature/deposer-candidature.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home2', component: Home2Component },
  { path: 'agence/anp-en-chiffres', component: ANPEnChiffresComponent },
  { path: 'agence/rapportsannuels', component: RapportsAnnuelsComponent },
  { path: 'agence/organisation', component: OrganisationComponent },
  { path: 'services/statistiques', component: StatistiquesComponent },
  { path: 'services/statistiques-national', component: StatistiquesNationalComponent },
  { path: 'agence/historique', component: HistoriqueComponent },
  { path: 'agence/:type', component: StatiquePageComponent },
  { path: 'missions/:type', component: StatiquePageComponent },
  { path: 'grands-chantiers/chantiers-infrastructures', component: ChantiersInfrastructuresComponent },
  { path: 'grands-chantiers/chantiers-infrastructures/:port', component: PortComponent },
  { path: 'grands-chantiers/:type', component: StatiquePageComponent },
  { path: 'portmaroc', component: PortMarocComponent },
  { path: 'port', component: PortDetailComponent },
  {
    path: 'port/:port', component: PortDetailComponent,
    children: [{ path: 'page/:page', component: PortcontentComponent }]
  }, 
  // { path: 'services/portnet', component: PortnetServicesComponent },
  { path: 'services/appel-manifestation', component: AppelManifestationComponent },
  { path: 'services/societesautorisees', component: SocietesautoriseesComponent },
  { path: 'services/appel-concurrence', component: AppelConcurrenceComponent },
  { path: 'services/appel-concurrence2', component: AppelConsurrence2Component },
  { path: 'services/appel-concurrence2/:Id', component: AppelConsurrence2Component },
  { path: 'services/programme-previsionel', component: ProgrammePrevComponent },
  { path: 'services/consignation-ports', component: ConsignationPortsComponent },
  { path: 'services/mvm-navires', component: MvmNaviresComponent },
  { path: 'services/mvm-navires-autorisee', component: MvmNaviresAutoriseeComponent },
  { path: 'services/smart-gate', component: SmartGateComponent },
  { path: 'services/smart-gate/:service/:nbrC', component: SmartGateComponent },
  { path: 'services/smart-gate/:service/:nbrC/:nmRdv', component: SmartGateComponent },
  { path: 'services/portnet', component: PortnetServicesComponent },
  { path: 'services/accessport', component: GestionAccessComponent },
  { path: 'services/rapportsannuels', component: RapportsAnnuelsComponent },
  { path: 'services/appels-offres', component: AppelsOffresComponent },
  { path: 'services/appels-offres/:Id', component: AppelsOffresComponent },
  { path: 'services/:type', component: StatiquePageComponent },
  { path: 'publications/communique-presse', component: CommuniquesPresseComponent },
  { path: 'publications/phototheque', component: PhotothequeComponent },
  { path: 'publications/phototheque/:simulateur', component: PhotothequeComponent },
  { path: 'publications/centremedia', component: CentreMediaComponent },
  { path: 'publications/newsletter', component: NewsletterComponent },
  { path: 'publications/videotheque', component: VideothequeComponent },
  { path: 'publications/actualites', component: ActualitesComponent },
  { path: 'publications/actualites/:id', component: ActualitesComponent },
  { path: 'publications/offres-emplois', component: OffresEmploisComponent },
  { path: 'publications/offres-emplois/postuler/:Id', component: PostulerComponent },
  { path: 'publications/offres-emplois/deposer-candidature/:Id', component: DeposerCandidatureComponent },
  { path: 'publications/archive', component: ArchiveComponent },
  { path: 'publications/archive/:id', component: ActualitesComponent },
  { path: 'publications/offres-emplois/:Id', component: OffresEmploisComponent },
  { path: 'publications/rapportsannuels', component: RapportsAnnuelsComponent },
  { path: 'publications/:type', component: StatiquePageComponent },
  { path: 'grandes-chantier/securiteportuaire', component: SecuritePortuaireComponent },
  { path: 'grandes-chantier/portnet', component: PortnetComponent },
  { path: 'grandes-chantier/:type', component: StatiquePageComponent },
  { path: 'espace-professionnel/tarifs-publics-plafonds', component: TarifsPublicsPlafondsComponent },
  { path: 'espace-professionnel/:type', component: StatiquePageComponent },
  { path: 'formation-portuaire/:type', component: StatiquePageComponent },
  { path: 'acces-rapide/contact', component: ContactComponent },
  { path: 'acces-rapide/lexique', component: LexiqueComponent },
  { path: 'acces-rapide/plan-site', component: PlanSiteComponent },
  { path: 'acces-rapide/:type', component: StatiquePageComponent },
  { path: 'recherche-parametres', component: SearchConfigComponent },
  { path: 'recherche', component: RechercheComponent },
  { path: 'fra', component: Home2Component },
  { path: 'arb', component: Home2Component },
  { path: 'eng', component: Home2Component },
  { path: 'page404', component: Page404Component },
  { path: '**', redirectTo: 'page404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }]
})
export class AppRoutingModule { }

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(url.toLowerCase());
  }
}